import { datadogLogs, StatusType } from '@datadog/browser-logs';

export const initLogging = () => {
  datadogLogs.init({
    clientToken: `${process.env.REACT_APP_DATADOG_RUM_CLIENT_ID}`,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    service: 'screener-questions',
    env: process.env.NODE_ENV,
    version: process.env.REACT_APP_GIT_SHA
  });
};

interface LogProps {
  message: string;
  context?: object;
  status?: StatusType;
}

export const getCorrelationId = () =>
  datadogLogs.getInternalContext()?.session_id || 'NOT_SET';

export const createLog = ({ status = 'debug', message, context }: LogProps) => {
  datadogLogs.logger.log(
    `${message} [correlation-id=${getCorrelationId()}]`,
    context,
    status
  );
};
